export * from "./bncc";
export * from "./debounce";
export * from "./error";
export * from "./group-by";
export * from "./is-html";
export * from "./is-image";
export * from "./is-touch-device";
export * from "./process-files-s3";
export const isIOSApp = Boolean(
  typeof window !== "undefined" &&
    ((window as any).isDeltaNativeApp === true ||
      Boolean((window as any).webkit?.messageHandlers?.signInGoogle))
);
export const isWebKit = isIOSApp;
export * from "./urlTofile";
export * from "./getKeysCache";
export * from "./getUrlFromNotification";
